import { render, staticRenderFns } from "./invite_collaborators_modal.vue?vue&type=template&id=6189bcb6&scoped=true&"
import script from "./invite_collaborators_modal.vue?vue&type=script&lang=js&"
export * from "./invite_collaborators_modal.vue?vue&type=script&lang=js&"
import style0 from "./invite_collaborators_modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./invite_collaborators_modal.vue?vue&type=style&index=1&id=6189bcb6&lang=scss&scoped=true&"
import style2 from "./invite_collaborators_modal.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189bcb6",
  null
  
)

export default component.exports